import { ReactElement } from 'react'
import Head from 'next/head'

const SEOAIBolit = (): ReactElement => {
  const dataFaq = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Как AI-Bolit помогает врачу экономить время?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'AI-Bolit предоставляет мгновенный доступ к актуальным клиническим рекомендациям, позволяя получать точные ответы на ваши вопросы за считанные секунды, что особенно важно в условиях ограниченного времени на прием пациента.',
        },
      },
      {
        '@type': 'Question',
        name: 'Является ли информация в AI-Bolit достоверной?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, вся информация в AI-Bolit основана на проверенных клинических рекомендациях, постоянно обновляется и соответствует актуальным медицинским стандартам.',
        },
      },
    ],
  }

  const dataMain = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'AI-Bolit',
    applicationCategory: 'MedicalApplication',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'RUB',
    },
    operatingSystem: 'Web',
    description:
      'AI-Bolit — инновационный сервис для врачей, объединяющий искусственный интеллект с базой клинических рекомендаций для быстрого доступа к медицинской информации',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      ratingCount: '1250',
    },
  }

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(dataMain) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(dataFaq) }}
      />
    </Head>
  )
}

export default SEOAIBolit
